let activeNotificationsLoad = null

const state = () => ({
    companyId: null,
    events: {},
    dailyCap: {
        email: 0,
        sms: 0
    },
    loading: false,
    loaded: false,
    error: null,
    saving: false,
    saveError: null,
    deletingRuleId: null
})

const mutations = {
    setNotificationsLoading(state, loading) {
        state.loading = loading
    },
    setNotificationsError(state, error) {
        state.error = error
    },
    setNotificationsSaving(state, saving) {
        state.saving = saving
    },
    setNotificationsSaveError(state, error) {
        state.saveError = error
    },
    setNotificationsDeletingRuleId(state, ruleId) {
        state.deletingRuleId = ruleId
    },
    setNotificationsPayload(state, payload) {
        state.companyId = payload.company_id ?? null
        state.events = payload.events && typeof payload.events === 'object' ? payload.events : {}
        state.dailyCap = {
            email: Number(payload.daily_cap?.email) || 0,
            sms: Number(payload.daily_cap?.sms) || 0
        }
        state.loaded = true
        state.error = null
    },
    resetNotifications(state) {
        state.companyId = null
        state.events = {}
        state.dailyCap = { email: 0, sms: 0 }
        state.loading = false
        state.loaded = false
        state.error = null
        state.saving = false
        state.saveError = null
        state.deletingRuleId = null
    }
}

const actions = {
    loadNotifications({ commit, state }, { vueInstance, force = false }) {
        if (state.loaded && !force) return Promise.resolve(state.events)
        if (activeNotificationsLoad) return activeNotificationsLoad

        commit('setNotificationsLoading', true)
        commit('setNotificationsError', null)

        activeNotificationsLoad = vueInstance
            .$fetch(vueInstance.$env.GOLIA_API + '/notifications')
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Notifications request failed with status ${response.status}`)
                }
                return response.json()
            })
            .then((response) => {
                const payload = response?.data?.events ? response.data : response
                commit('setNotificationsPayload', payload || {})
                return payload
            })
            .catch((error) => {
                commit('setNotificationsError', error)
                throw error
            })
            .finally(() => {
                commit('setNotificationsLoading', false)
                activeNotificationsLoad = null
            })

        return activeNotificationsLoad
    },
    createNotification({ commit }, { vueInstance, payload }) {
        commit('setNotificationsSaving', true)
        commit('setNotificationsSaveError', null)

        return vueInstance
            .$fetch(vueInstance.$env.GOLIA_API + '/notifications', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Notification creation failed with status ${response.status}`)
                }
                return response.json()
            })
            .catch((error) => {
                commit('setNotificationsSaveError', error)
                throw error
            })
            .finally(() => commit('setNotificationsSaving', false))
    },
    updateNotification({ commit }, { vueInstance, ruleId, payload }) {
        commit('setNotificationsSaving', true)
        commit('setNotificationsSaveError', null)

        return vueInstance
            .$fetch(
                vueInstance.$env.GOLIA_API + '/notifications/' + encodeURIComponent(ruleId),
                {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payload)
                }
            )
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Notification update failed with status ${response.status}`)
                }
                if (response.status === 204) return null
                return response.json()
            })
            .catch((error) => {
                commit('setNotificationsSaveError', error)
                throw error
            })
            .finally(() => commit('setNotificationsSaving', false))
    },
    deleteNotification({ commit }, { vueInstance, ruleId }) {
        commit('setNotificationsDeletingRuleId', ruleId)

        return vueInstance
            .$fetch(
                vueInstance.$env.GOLIA_API + '/notifications/' + encodeURIComponent(ruleId),
                { method: 'DELETE' }
            )
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Notification deletion failed with status ${response.status}`)
                }
                return true
            })
            .finally(() => commit('setNotificationsDeletingRuleId', null))
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
